<template>
    <div class="lineSelector base-button">
        <div></div>
    </div>
</template>

<script>
export default { 
    name: 'LineSelector',
    methods: {
        
    },

}
</script>

<style scoped>
    .lineSelector{
        width: .666667rem;
        height: .453333rem;
    }

    .lineSelector::before{
        height: .306667rem;
        top: 1px;
    }

    .lineSelector::after{
        height: .306667rem;
        top: 1px;
    }

    .lineSelector>div:first-child{
        display: inline;
        width: .4rem;
        height: .08rem;
        background-color: #fff;
        border-radius: 1px;
    }
</style>